// extracted by mini-css-extract-plugin
module.exports = {"root":"CouponTypeSelect_root__M5TJo","tab":"CouponTypeSelect_tab__JNDsP","tabContent":"CouponTypeSelect_tabContent__n1txv"};